import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DatePickerService {
  public onTogglePicker = new BehaviorSubject<{ open: string; show: boolean; positionX: number; positionY: number }>(
    opener
  );

  constructor() {}

  toggleDatePicker(opener) {
    this.onTogglePicker.next(opener);
  }
}
